<main class="flex w-full min-h-screen">
  <aside class="w-0 lg:w-[260px] min-h-screen transition-all pt-4 overflow-y-auto rounded-tr-3xl rounded-br-3xl bg-background-dark flex flex-col">
    <ng-container *ngTemplateOutlet="menu"></ng-container>
  </aside>

  <div class="w-full lg:w-[calc(100%-260px)] min-h-[calc(100vh-5rem)] bg-background">
    <router-outlet />
  </div>
</main>

<p-drawer
  [visible]="(showMenuDrawer$ | async) || false"
  [closable]="false"
  (visibleChange)="toggleMenuDrawer($event)"
  styleClass="w-64 rounded-tr-3xl rounded-br-3xl"
>
  <ng-container *ngTemplateOutlet="menu"></ng-container>
</p-drawer>

<ng-template #menu>
  <div routerLink="/" class="flex items-center justify-center cursor-pointer my-8">
    <img class="h-12 max-w-52" src="assets/images/logo-{{ (theme$ | async)?.name || '' }}.svg" alt="logo">
  </div>
  <div class="w-full h-1 bg-primary mb-4"></div>
  <p-panelmenu [model]="menuItems" [multiple]="true" class="w-full">
  </p-panelmenu>
  <div class="flex flex-1 flex-col justify-end p-4 h-max">
    <span class="text-zinc-400 flex items-center gap-2">
      <!-- <span>APP</span> -->
      <span>v{{ version }}</span>
      <!-- <p-divider layout="vertical" />
      <span>API</span>
      <span>v{{ version }}</span> -->
    </span>
  </div>
</ng-template>
